import React, { useEffect, useState, useImperativeHandle } from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Paper from "@mui/material/Paper";
import {
    Grid,
    Table,
    TableColumnResizing,
    TableColumnVisibility,
    TableTreeColumn,
} from "@devexpress/dx-react-grid-material-ui";

import {
    SelectionState,
    IntegratedSelection,
    TreeDataState,
    CustomTreeData,
    DataTypeProvider
} from "@devexpress/dx-react-grid";
import { makeTreeFromFlatList } from "../utils";
import Spinner from "./Spinner";
function LookupTreeView(props, ref) {
    useImperativeHandle(ref, () => ({
        setTitle,
        setDataSource,
        setLeafPrefix,
    }));

    const [loading, setLoading] = useState(false);
    const [leafPrefix, setLeafPrefix] = useState(props.leafPrefix);
    const [title, setTitle] = useState(props.title || "Choose...");
    const [dataSource, setDataSource] = useState(
        props.dataSource || (() => {})
    );

    const [columns, setColumns] = useState([
        { name: "icon", title: "Icon" },
        { name: "name", title: "Name" },
        {
            name: "description",
            title: "Description",
        },
        {
            name: "type",
            title: "Type",
        },
    ]);
    const [defaultColumnWidths] = useState([
        { columnName: "icon", width: 50 },
        { columnName: "name", width: 300 },
        { columnName: "description", width: 300 },
        { columnName: "type", width: 100 },
    ]);
    const [defaultHiddenColumnNames] = useState([]);
    const [tableColumnExtensions] = useState([
        { columnName: "name", width: 300 },
    ]);

    const [availableList, setAvailableList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);

    const [availableNodes, setAvailableNodes] = useState([]);
    const [selectedNodes, setSelectedNodes] = useState([]);

    useEffect(() => {
        /** raise an event */
        if (availableList.length === 0) return;
        const selectedEntities = availableList.filter((e) => {
            return (
                selectedList.includes(e.__nodeId__) &&
                e.__nodeId__.startsWith(leafPrefix)
            );
        });
        const uniqueEntities = _.uniqBy(selectedEntities, (i) => i.__nodeId__);
        if (props.onSelected) {
            props.onSelected(uniqueEntities);
        }
    }, [selectedList]);

    function getChildNodes(availableList, nodeId) {
        const node = availableList.filter(
            (item) => item.__nodeId__ == nodeId
        )[0];
        if (node.children.length === 0) return nodeId;
        return _.flatten([
            nodeId,
            ...node.children.map((n) => {
                return getChildNodes(availableList, n.__nodeId__);
            }),
        ]);
    }

    useEffect(() => {
        const recursivelySelectedNodes = _.uniq(
            _.flatten(
                selectedNodes.map((nodeId) => {
                    return getChildNodes(availableList, nodeId);
                })
            )
        );
        _.remove(selectedNodes);
        recursivelySelectedNodes.map((n) => {
            if (!_.includes(selectedNodes, n)) {
                selectedNodes.push(n);
            }
        });
        setSelectedList(recursivelySelectedNodes);
    }, [selectedNodes]);

    useEffect(() => {
        if (!availableList || availableList.length === 0) return;
        const hierarchicalNodes = makeTreeFromFlatList(
            availableList,
            (item) => item.__parentNodeId__,
            (item, getChildrenFor) => {
                item.children = getChildrenFor(item.__nodeId__);
                return item;
            },
            null
        );
        setAvailableNodes(hierarchicalNodes);
    }, [availableList]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const data = await dataSource;
            setAvailableList(data);
            setLoading(false);
        })();
    }, [dataSource]);

    function IconFormatter ({value}) {
        return <i className={`fa ${value}`}></i>
    }
    function IconProvider (props) {
       return <DataTypeProvider
            formatterComponent={IconFormatter}
            {...props}
            />
    } 

    return (
        <>
            <Modal
                show={props.visible}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                centered={true}
                dialogClassName="modal-xl searchModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="searchBody">
                        {loading && <Spinner></Spinner>}
                        <div>
                            <Paper>
                                <Grid
                                    rows={availableNodes}
                                    columns={columns}
                                    getRowId={(row) => row.__nodeId__}
                                >
                                    <SelectionState
                                        selection={selectedNodes}
                                        onSelectionChange={(e) => {
                                            setSelectedNodes(e);
                                        }}
                                    />

                                    <TreeDataState defaultExpandedRowIds={[]} />
                                    <CustomTreeData
                                        getChildRows={(row, rootRows) => {
                                            if (!row) {
                                                return rootRows;
                                            }
                                            if (!row.children || row.children.length === 0) {
                                                return null;
                                            }
                                            return row.children;
                                        }}
                                    ></CustomTreeData>
                                    <IntegratedSelection />
                                    <Table
                                        columnExtensions={tableColumnExtensions}
                                        messages={{
                                            noData: "No options available!",
                                        }}
                                    />
                                    <TableColumnResizing
                                        defaultColumnWidths={
                                            defaultColumnWidths
                                        }
                                    />
                                    <IconProvider for={["icon"]} />
                                    <TableTreeColumn
                                        for="name"
                                        showSelectionControls
                                        showSelectAll
                                    />
                                    <TableColumnVisibility
                                        defaultHiddenColumnNames={
                                            defaultHiddenColumnNames
                                        }
                                    />
                                </Grid>
                            </Paper>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default React.forwardRef(LookupTreeView);
